export default function useURLSearchParams() {
  function removeAllSearchParamsFromURL() {
    const baseUrl = window.location.href.split('?')[0];
    window.history.replaceState('name', '', baseUrl);
  }

  return { removeAllSearchParamsFromURL };
}
